import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import Axios from "axios";
import FormHelper from "@Scripts/Common/FormHelper";
import Localizer from "@Scripts/Common/Localizer";

@Component({ name: "AccountVisitorEdit" })
export default class AccountVisitorEdit extends Vue {
    public localizer: any = Localizer;
    public formHelper: any = FormHelper;
    public isLoading: boolean = false;
    public isSuccess: boolean = false;
    public countries: any[] = [];
    public markets: any[] = [];
    public editData: any = null;
    public formData: any = {};
    public validationErrors: any[] = [];
    public isPrivacyPolicyShow: boolean = false;
    public privacyPolicy: string = null;

    @Prop() readonly returnUrl: string;

    get routes() {
        return (<any>window).App.routes;
    }

    public created() {
        this.getData();
    }

    public async getData() {
        this.editData = (await Axios.post(this.routes.AccountVisitor_GetEditData, null, { headers: { "RequestVerificationToken": FormHelper.getRequestVerificationToken() } })).data;
        this.formData.name = this.editData.name;
        this.formData.surname = this.editData.surname;
        this.formData.company = this.editData.company;
        this.formData.country = this.editData.country;
        this.formData.location = this.editData.location;
        this.formData.address = this.editData.address;
        this.formData.postCode = this.editData.postCode;
        this.formData.workingRole = this.editData.workingRole;
        this.formData.markets = this.editData.selectedMarkets;

        this.countries = this.editData.countries;
        this.markets = this.editData.markets;
    }

    public async showPrivacyPolicy() {
        this.isPrivacyPolicyShow = !this.isPrivacyPolicyShow;

        if (!this.privacyPolicy){
            let response = await Axios.post(this.routes.Terms_GetPrivacyPolicy);   
            this.privacyPolicy = Object.freeze(response.data.description);
        }
    }

    public async submitForm() {
        FormHelper.removeFocus();
        this.validationErrors = [];    
        this.isLoading = true;

        try {
            let result = (await Axios.post(this.routes.AccountVisitor_Edit, this.formData, { headers: { "RequestVerificationToken": FormHelper.getRequestVerificationToken() } })).data;

            this.isSuccess = true;

            window.location.href = result.redirectUrl ? result.redirectUrl : (this.returnUrl ? this.returnUrl : "/");
        } catch (error) {
            if (error.response.status === 400) {
                this.validationErrors = FormHelper.getValidationErrors(error.response.data);
            }
        }

        this.isLoading = false;
    }
};